/** Full-screen quiz page — renders outside the AppShell for immersive experience. */

import { useParams, useNavigate } from "react-router-dom";
import { api } from "@/api/client";
import { JudgeQuiz } from "@/components/quiz/JudgeQuiz";
import { ProducerQuiz } from "@/components/quiz/ProducerQuiz";
import { CompetitionManagerQuiz } from "@/components/quiz/CompetitionManagerQuiz";
import type { CourseCompletion } from "@/types";

const QUIZ_MAP: Record<string, React.FC<{ onPass: () => void; onClose: () => void }>> = {
  judge: JudgeQuiz,
  producer: ProducerQuiz,
  competition_manager: CompetitionManagerQuiz,
};

const QUIZ_TITLES: Record<string, string> = {
  judge: "Judge Certification Quiz",
  producer: "Producer Certification Quiz",
  competition_manager: "Competition Manager Certification Quiz",
};

export function QuizPage() {
  const { courseType } = useParams<{ courseType: string }>();
  const navigate = useNavigate();

  const QuizComponent = courseType ? QUIZ_MAP[courseType] : null;

  if (!QuizComponent) {
    return (
      <div style={{ display: "flex", justifyContent: "center", alignItems: "center", minHeight: "100vh", background: "var(--c-bg)" }}>
        <div style={{ textAlign: "center", color: "var(--c-text)" }}>
          <h1 style={{ fontSize: 24, fontWeight: 800 }}>Quiz not found</h1>
          <button className="btn btn-secondary" style={{ marginTop: 16 }} onClick={() => navigate("/training")}>
            Back to Training
          </button>
        </div>
      </div>
    );
  }

  return (
    <div style={{
      minHeight: "100vh", background: "var(--c-bg)", color: "var(--c-text)",
      fontFamily: "var(--font-sans)", padding: "0 24px 24px",
    }}>
      {/* Minimal header */}
      <div style={{
        display: "flex", justifyContent: "space-between", alignItems: "center",
        padding: "12px 0", borderBottom: "1px solid var(--c-border)", marginBottom: 16,
      }}>
        <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
          <span style={{ fontFamily: "var(--font-mono)", fontWeight: 800, fontSize: 15, letterSpacing: 2 }}>RALEY</span>
          <span style={{ fontSize: 12, color: "var(--c-text-dim)" }}>
            {courseType ? QUIZ_TITLES[courseType] ?? "Quiz" : "Quiz"}
          </span>
        </div>
        <button
          className="btn btn-ghost btn-sm"
          onClick={() => navigate("/training")}
        >
          Exit Quiz
        </button>
      </div>

      <QuizComponent
        onPass={async () => {
          try {
            await api.post<CourseCompletion>(`/api/courses/complete/${courseType}`);
          } catch {
            // Already completed — that's fine
          }
          navigate("/training");
        }}
        onClose={() => navigate("/training")}
      />
    </div>
  );
}
